import { LensCustomizationSchema, LensCustomization } from '@ca/common'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

const useLensesHookForm = (defaults?: LensCustomization) => {
  const form = useForm<LensCustomization, any, LensCustomization>({
    defaultValues: defaults ?? {
      thickness_balance: false,
    },
    // react-hook-form ≥7.55: zodResolver infers z.input<schema> (z.coerce fields have `unknown`
    // input type) as TFieldValues, mismatching LensCustomization. `as any` preserves pre-7.55
    // behavior — Zod still validates and transforms at runtime. See docs/expo54-migration.md § Known Issues.
    resolver: zodResolver(LensCustomizationSchema) as any,
  })

  return form
}

export type LensesHookForm = ReturnType<typeof useLensesHookForm>

export default useLensesHookForm
